import React, { Component, PropTypes } from 'react';

import ChatIcon from 'material-ui/svg-icons/communication/chat';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import WalkThruIcon from 'material-ui/svg-icons/maps/directions';
import WhatsHotIcon from 'material-ui/svg-icons/social/whatshot';

import IconWithCounter from '../notification/icon-with-counter';
import HoverableMenuItem from '../hoverable-menu-item';

class SupportContainer extends Component {

  render = () => {
    const { helpwidget, openWalkThru, walkthru } = this.props;

    const menuItems = [
      {
        text: 'Support Articles & Videos',
        onTouchTap: () => {
          window.open('http://support.tourconnect.com');
        },
        icon: <SchoolIcon />,
      },
      {
        text: 'Live Chat',
        onTouchTap: () => window.Intercom('show'), // eslint-disable-line new-cap
        icon: <ChatIcon />,
      },
      {
        text: 'New Releases!',
        onTouchTap: () => window.Beamer.show(),
        icon: <IconWithCounter
          style={{ top: '-4px' }}
          icon={<WhatsHotIcon color="rgb(255, 0, 0)" style={{ fill: 'rgb(255, 0, 0)' }} />}
          count={helpwidget.newFeaturesCount}
        />,
      },
    ];

    if (walkthru.isTourReady) {
      const walkthruMenuItem = {
        text: 'Features Walk Through',
        onTouchTap: openWalkThru,
        icon: <WalkThruIcon />,
      };
      menuItems.splice(2, 0, walkthruMenuItem);
    }

    return (<HoverableMenuItem
      {...this.props}
      className="nav-link"
      activeRoutes={[]}
      routeName={""}
      showSubMenu
      subMenuItems={menuItems}
    >
      Help &amp; Support
    </HoverableMenuItem>);
  }
}


export default SupportContainer;



// WEBPACK FOOTER //
// ./src/app/components/app-bar/support/container.jsx